import { useCallback, useEffect, useRef } from 'react';
import notificationSound from '../Sounds/universfield-new-notification-056-494256.mp3';

export default function useNotificacionSonido({ volume = 0.6 } = {}) {
  const audioRef = useRef(null);
  const unlockedRef = useRef(false);

  useEffect(() => {
    const audio = new Audio(notificationSound);
    audio.preload = 'auto';
    audio.volume = volume;
    audioRef.current = audio;

    const unlock = () => {
      if (unlockedRef.current || !audioRef.current) return;

      const current = audioRef.current;
      current.muted = true;

      const attempt = current.play();
      const release = () => {
        current.pause();
        current.currentTime = 0;
        current.muted = false;
      };

      if (attempt && typeof attempt.then === 'function') {
        attempt
          .then(() => {
            release();
            unlockedRef.current = true;
          })
          .catch(() => {
            current.muted = false;
          });
      } else {
        release();
        unlockedRef.current = true;
      }

      if (unlockedRef.current) {
        window.removeEventListener('pointerdown', unlock);
        window.removeEventListener('keydown', unlock);
      }
    };

    window.addEventListener('pointerdown', unlock);
    window.addEventListener('keydown', unlock);

    return () => {
      window.removeEventListener('pointerdown', unlock);
      window.removeEventListener('keydown', unlock);
      audio.pause();
      audio.currentTime = 0;
    };
  }, [volume]);

  const play = useCallback(() => {
    const audio = audioRef.current;
    if (!audio) return;

    audio.currentTime = 0;
    audio.volume = volume;

    const attempt = audio.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(() => {});
    }
  }, [volume]);

  return play;
}
